/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenderEndpointRequest
 */
export interface RenderEndpointRequest {
    /**
     * 
     * @type {object}
     * @memberof RenderEndpointRequest
     */
    sequence: object;
    /**
     * 
     * @type {object}
     * @memberof RenderEndpointRequest
     */
    project: object;
    /**
     * 
     * @type {object}
     * @memberof RenderEndpointRequest
     */
    options: object;
}

export function RenderEndpointRequestFromJSON(json: any): RenderEndpointRequest {
    return RenderEndpointRequestFromJSONTyped(json, false);
}

export function RenderEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenderEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequence': json['sequence'],
        'project': json['project'],
        'options': json['options'],
    };
}

export function RenderEndpointRequestToJSON(value?: RenderEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequence': value.sequence,
        'project': value.project,
        'options': value.options,
    };
}


